import React, { useEffect, useState } from 'react'
import { Images } from '../../../assests'
import { Autocomplete, Box, Button, CardMedia, Dialog, DialogContent, Divider, Grid, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material'
import Colors from '../../../assests/style'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import OrderServices from '../../../services/OrderServices';
import { PrimaryButton, SecondaryButton } from '../../../components/Buttons';
import ConfirmationDialog from '../../../components/DialogBoxComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { showErrorToast } from '../../../components/Toaster';
import { currencyType } from '../../../utils';
import { Controller, useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';



const Cart = () => {
    const navigate = useNavigate()
    const { control, handleSubmit, setValue } = useForm({
        defaultValues: {
            states: null,
            cities: null,
        },
    });
    const [cartItems, setCartItems] = useState([])
    const [confirmationDialog, setConfirmationDialog] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [originalArray, setOriginalArray] = useState([])
    const CustomPaper = (props) => (
        <Paper
            {...props}
            sx={{
                backgroundColor: "#101a33", // Navy blue background
                color: "white",
                borderRadius: "10px",
                mt: 1, // small margin top
            }}
        />
    );
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    const onSubmit = (data) => {
        console.log("Form Data:", data);
        localStorage.setItem('state', data?.states?.emirate)
        localStorage.setItem('city', data?.cities?.emirate)
        setOpen(false);
    };

    const useStyles = styled({
        blurredBackground: {
            filter: "blur(12px)", // Apply the blur effect
            transition: "filter 0.3s ease", // Smooth transition
        },
        popupImage: {
            width: "100%",
            maxWidth: "300px",
            margin: "0 auto",
        },
        popupButton: {
            backgroundColor: "#00a8ff", // Same button color
            color: "#fff",
            marginTop: "20px",
        },
    });

    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const { state } = useLocation()
    console.log(state, 'statestate');
    let vendor = localStorage.getItem('merchant')
    vendor = JSON.parse(vendor)
    const UpdateCart = async (cartData) => {

        console.log(cartItems, 'cartItems');
        if (vendor?.name) {


            try {
                let obj = {

                    items: cartData ? cartData : cartItems,
                    // vendor_id: vendor?._id
                }

                const { message } = await OrderServices.UpdateCart(obj)
                Swal.fire({
                    title: message,

                    icon: "success",
                    background: "#0f172a", // Change to your desired background color
                    color: "#fff", // Change to your desired text color
                }).then((result) => {
                    if (result.isConfirmed) {
                        getCartData()
                        // window.location.href = '/my-account'; // Navigate to the home page
                    }
                });

            } catch (error) {
                console.log(error);
            } finally {

            }
        }
        else {
            showErrorToast('Please Select Vendor')
        }

    }


    const handleDelete = async (item) => {
        setConfirmationDialog(false)
        let selectedId = selectedItem?._id
        setCartItems(cartItems?.filter((item => item?._id != selectedId)))

        let cartData = cartItems?.filter((item => item?._id != selectedId))
        const { totalPrice, totalQty } = cartItems?.reduce(
            (acc, item) => {
                acc.totalPrice += item.price * item.qty;
                acc.totalQty += item.qty;
                return acc;
            },
            { totalPrice: 0, totalQty: 0 }
        );

        console.log(totalPrice, 'totalPrice');

        if (cartData.length == 0) {

            UpdateCart(cartData)
        }



    }

    useEffect(() => {
        const { totalPrice, totalQty } = cartItems?.reduce(
            (acc, item) => {
                acc.totalPrice += item.price * item.qty;
                acc.totalQty += item.qty;
                return acc;
            },
            { totalPrice: 0, totalQty: 0 }
        );

        setTotalAmount(totalPrice);

    }, [cartItems])

    const [totalAmount, setTotalAmount] = useState(null)
    const getCartData = async (sendData) => {
        console.log(sendData, 'data');
        try {
            let params = {

            }
            const { data } = await OrderServices.CartData(params)
            console.log(data?.cart?.designs, 'extractedDetails');
            const extractedDetails = data?.cart?.designs?.flatMap(item =>
                item.details.map(detail => ({
                    ...detail,
                    generated_art: item?.design_id?.generated_art,
                    design_id: item?.design_id?._id,
                    design: item?.design_id?.design
                }))
            );
            if (extractedDetails?.length > 0 && !vendor) {
                navigate('/merchants')

            }
            console.log(extractedDetails, 'extractedDetails');

            const { totalPrice, totalQty } = extractedDetails?.reduce(
                (acc, item) => {
                    acc.totalPrice += item.price * item.qty;
                    acc.totalQty += item.qty;
                    return acc;
                },
                { totalPrice: 0, totalQty: 0 }
            );

            setTotalAmount(totalPrice);
            setOriginalArray(totalPrice)
            setCartItems(extractedDetails)

        } catch (error) {
            console.log(error);
        } finally {

        }
    }

    // ✅ Calculate Total
    const total = cartItems?.reduce((acc, item) => {
        const itemPrice = getTshirtPrice(
            vendor?.products[0],
            item?.print_intensity,
            (
                (item?.design?.frontPic?.length > 0 || item?.design?.frontText?.length > 0) &&
                (item?.design?.backPic?.length > 0 || item?.design?.backText?.length > 0)
            ) ? "double_side" : "one_side",
            (item?.design?.frontPic?.length > 1 || item?.design?.backPic?.length > 1),
            item?.design
        );

        return acc + (itemPrice * item.qty);
    }, 0);


    // Add the handlers outside the component mapping
    const handleIncrease = (index) => {
        const updatedItems = [...cartItems];
        updatedItems[index].qty += 1;
        setCartItems(updatedItems);
    };

    const handleDecrease = (index) => {
        const updatedItems = [...cartItems];
        if (updatedItems[index].qty > 1) {
            updatedItems[index].qty -= 1;
            setCartItems(updatedItems);
        }
    };
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])
    const getStates = async (country) => {
        try {
            let params = { country: process.env?.REACT_APP_COUNTRY };
            const { data } = await OrderServices.getStates(params);
            console.log(data, 'countries');
            setStates(
                data?.states?.map((item, index) => ({
                    _id: index,
                    emirate: item
                }))
            );





        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const getCities = async (value) => {
        console.log(value, 'value');

        try {
            let params = {
                country: process.env?.REACT_APP_COUNTRY,
                state: value?.emirate

            };
            const { data } = await OrderServices.getCities(params);
            console.log(data?.cities?.map((item, index) => ({
                _id: index,
                emirate: item
            })), 'cities');
            setCities(
                data?.cities?.map((item, index) => ({
                    _id: index,
                    emirate: item
                }))
            );




        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    useEffect(() => {
        getStates()
        getCartData()
    }, [])
    function getTshirtPrice(product, type, side, hasAdditional = false, item) {
        if (!product || !type || !side) return null;
        console.log(item, product, type, side, hasAdditional, 'hasAdditional');
        let totalLength = (item?.frontPic?.length - 1 || 0) + (item?.backPic?.length - 1 || 0)
        console.log(totalLength, 'basePrice');


        let basePrice = product[`${side}_${type}`] || 0;

        if (hasAdditional) {
            basePrice += product[`additional_${type}`] * (totalLength || 0) || 0;
        }
        console.log(basePrice, 'basePrice');

        return parseFloat(basePrice);
    }




    return (
        <div>
            <Helmet>
        <title>Your Cart | Print Me Up</title>
        <meta
          name="description"
          content="Review the items in your Print Me Up cart before checkout. Adjust quantities, remove products, and view your total order cost."
        />
        <meta
          name="keywords"
          content="shopping cart, printmeup cart, custom t-shirt cart, print on demand, order summary"
        />
        <link rel="canonical" href="https://pk.printmeup.ai/cart" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Your Cart | Print Me Up" />
        <meta
          property="og:description"
          content="View and manage your Print Me Up cart before proceeding to checkout."
        />
        <meta
          property="og:image"
          content="https://pk.printmeup.ai/images/cart-banner.jpg"
        />
        <meta property="og:url" content="https://pk.printmeup.ai/cart" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Print Me Up" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Your Cart | Print Me Up" />
        <meta
          name="twitter:description"
          content="Review your selected Print Me Up products and prepare for checkout."
        />
        <meta
          name="twitter:image"
          content="https://pk.printmeup.ai/images/cart-banner.jpg"
        />
        <meta name="twitter:site" content="@PrintMeUp" />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ShoppingCart",
            "name": "Print Me Up Cart",
            "url": "https://pk.printmeup.ai/cart",
            "description":
              "Review your custom print products before completing your purchase.",
            "publisher": {
              "@type": "Organization",
              "name": "Print Me Up",
              "logo": {
                "@type": "ImageObject",
                "url": "https://pk.printmeup.ai/static/media/mainlogo.615e917be0574c945659.png",
              },
            },
          })}
        </script>
      </Helmet>
            {/* ========== Confirmation Dialog ========== */}
            <ConfirmationDialog
                open={confirmationDialog}
                onClose={() => setConfirmationDialog(false)}
                message={"Confirm to delete?"}
                deleteBox={true}
                description={'Are you sure you want to delete this item from cart?'}
                sx={{
                    '& .MuiDialog-paper': {
                        width: { lg: '30% !important', md: '40% !important', sm: '50% !important', xs: '80% !important' },
                        height: "auto",
                        borderRadius: 2,
                        py: { xs: 2, md: 4 },
                        px: { xs: 3, md: 6 },
                        backgroundColor: '#0F172A'
                    }
                }}
                action={handleDelete}
            />
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="sm"
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "blur(8px)",
                        },
                    },
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: "#0C1427",
                        boxShadow: "none",
                        borderRadius: '12px'
                    },
                }}
            >
                <DialogContent>

                    <Typography className='heading-font' variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold' }}>
                        Select Delivery State & City
                    </Typography>
                    <Box
                        sx={{
                            backgroundColor: "#0C1427",
                            padding: "20px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                        component="form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Grid container spacing={2}>
                            {/* State Dropdown */}
                            <Grid item xs={12} sm={6} mt={2}>
                                <Controller
                                    name="states"
                                    control={control}
                                    rules={{ required: "State is required" }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            options={states || []}
                                            PaperComponent={CustomPaper}
                                            getOptionLabel={(option) => option?.emirate || ""}
                                            value={field.value || null}
                                            onChange={(e, newValue) => {
                                                field.onChange(newValue);
                                                getCities(newValue)
                                                setValue('cities', '')
                                                setSelectedState(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="States"
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                    variant="outlined"
                                                    sx={{
                                                        input: { color: "white" },
                                                        label: { color: "white" },
                                                        ".MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "white", borderRadius: "15px" },
                                                            "&:hover fieldset": { borderColor: "white" },
                                                            "&.Mui-focused fieldset": { borderColor: "white" },
                                                            backgroundColor: "#101a33",
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <>
                                                    <li {...props} style={{ color: "white", backgroundColor: "#101a33" }}>
                                                        {option.emirate}
                                                    </li>
                                                    <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />
                                                </>
                                            )}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    color: "white", // 👈 makes the dropdown arrow white
                                                },
                                                "& .MuiAutocomplete-listbox": { backgroundColor: "#101a33" },
                                                "& .MuiAutocomplete-option": { color: "white" },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* City Dropdown */}
                            <Grid item xs={12} sm={6} mt={2}>
                                <Controller
                                    name="cities"
                                    control={control}
                                    rules={{ required: "City is required" }}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete
                                            options={cities || []}
                                            PaperComponent={CustomPaper}
                                            getOptionLabel={(option) => option?.emirate || ""}
                                            value={field.value || null}
                                            onChange={(e, newValue) => {
                                                field.onChange(newValue);
                                                setSelectedCity(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="City"
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                    variant="outlined"
                                                    sx={{
                                                        input: { color: "white" },
                                                        label: { color: "white" },
                                                        ".MuiOutlinedInput-root": {
                                                            "& fieldset": { borderColor: "white", borderRadius: "15px" },
                                                            "&:hover fieldset": { borderColor: "white" },
                                                            "&.Mui-focused fieldset": { borderColor: "white" },
                                                            backgroundColor: "#101a33",
                                                        },
                                                    }}
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <>
                                                    <li {...props} style={{ color: "white", backgroundColor: "#101a33" }}>
                                                        {option.emirate}
                                                    </li>
                                                    <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />
                                                </>
                                            )}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    color: "white", // 👈 makes the dropdown arrow white
                                                },
                                                "& .MuiAutocomplete-listbox": { backgroundColor: "#101a33" },
                                                "& .MuiAutocomplete-option": { color: "white" },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <Box mt={3}>
                            <SecondaryButton
                                p="15px 30px"
                                fontWeight="bold"
                                color="#0F172A"
                                sx={{
                                    background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)",
                                    borderRadius: "15px",
                                    border: "none",
                                }}
                                title="Submit"
                                type="submit"
                            />
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '300px', // Adjust height as needed
                    display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    position: "relative"
                }}
            >
                {/* <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        width: "100%",
                        height: "100%",
                        background: Colors.backgroundColor1
                    }}
                /> */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <p className='banner-text heading-font' style={{ fontSize: '35px', textAlign: 'center', fontFamily: "Noto Sans, sans-serif", }}> My Cart  </p>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
            </Box>
            <Grid container justifyContent={'center'} py={10}>
                <Grid item lg={8} md={8} sm={12} xs={12}>
                    <Box sx={{ color: '#00bcd4', p: 4, borderRadius: 2 }}>
                        <Typography className='heading-font' variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold' }}>
                            Confirm <Box component={"span"} variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold', color: "white !important", WebkitTextFillColor: "white" }}  >Your Creation</Box> <Box className='heading-font' component={"span"} sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold' }}>Now</Box>
                        </Typography>
                        <p className='banner-text heading-font' style={{ fontSize: '25px', textAlign: 'center', fontFamily: "Noto Sans, sans-serif", marginBottom: '16px' }}>
                            Your Selected Vendor : {vendor?.name} </p>
                        <Box sx={{ backgroundColor: '#151d2f', p: 2, borderRadius: "15px", mb: 2, mt: 3, display: { lg: 'block', md: 'block', sm: 'none', xs: 'none' } }}>
                            <Grid container spacing={2} alignItems="center"  >
                                {/* Item Image */}
                                <Grid item xs={6} sx={{ color: '#878b94' }}>
                                    Name
                                </Grid>



                                {/* Price and Quantity */}
                                <Grid item xs={2} textAlign="center">
                                    <Typography sx={{ color: '#878b94' }}>Price </Typography>

                                </Grid>
                                <Grid item xs={2} textAlign="center">
                                    <Typography component="span" sx={{ color: '#878b94' }}>
                                        Quantity
                                    </Typography>
                                </Grid>
                                {/* Total and Remove Button */}
                                <Grid item xs={2} textAlign="center">
                                    <Typography sx={{ color: '#878b94' }}>Total</Typography>

                                </Grid>
                            </Grid>
                        </Box>
                        {cartItems?.length > 0 ? cartItems?.map((item, index) => (
                            <Box key={index} sx={{ backgroundColor: '#15273f', p: 2, borderRadius: "15px", mb: 2, position: 'relative' }}>
                                <Box component={'img'} width={'12px'} onClick={() => { setSelectedItem(item); setConfirmationDialog(true) }} src={Images.crossIcon} sx={{ position: 'absolute', top: 10, right: 10, fontWeight: 'bold', cursor: 'pointer' }} ></Box>
                                <Grid container spacing={2} alignItems="center">
                                    {/* Item Image */}
                                    <Grid item lg={6} md={6} sm={12} xs={12} display={'flex'} justifyContent={'flex-start'} alignItems={'center'} gap={2}>
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: '100px',
                                                height: 'auto',
                                                '&:hover .overlay': {
                                                    opacity: 1,
                                                },
                                            }}
                                        >
                                            <Box sx={{ p: '10px', backgroundColor: '#0BD1D14D', display: 'flex', justifyContent: 'center' }}>


                                                <Box
                                                    component="img"
                                                    src={item.generated_art}
                                                    alt="Item"
                                                    sx={{
                                                        width: '80px',
                                                        height: '90px',
                                                        borderRadius: 1,
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                className="overlay"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',  // semi-transparent overlay
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    opacity: 0,
                                                    transition: 'opacity 0.3s ease',
                                                    borderRadius: 1,
                                                    color: 'white',
                                                }}
                                            >
                                                <Button
                                                    onClick={() => navigate(`/order/${item?.design_id}`)}
                                                    sx={{ color: 'white', textTransform: 'none' }}
                                                >
                                                    Preview
                                                </Button>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Typography variant="body2">Age Group: <span style={{ color: 'white' }}>{item?.size_type} </span></Typography>
                                            <Typography variant="body2">Size:  <span style={{ color: 'white' }}>{item?.size} </span></Typography>
                                            {/* <Typography variant="body2">Shirt Quality:  <span style={{ color: 'white', textTransform: 'capitalize' }}>{item?.print_intensity}</span></Typography>
                                            <Typography variant="body2">Print Quality:<span style={{ color: 'white', textTransform: 'capitalize' }}> {item?.shirt_type}</span></Typography> */}
                                        </Box>
                                    </Grid>

                                    {console.log(item)}

                                    {/* Price and Quantity */}
                                    <Grid item lg={2} md={2} sm={4} xs={4} textAlign="center">
                                        <Typography sx={{ color: 'white' }}>    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {vendor ? item?.price : '-'}</Typography>

                                    </Grid>
                                    <Grid item lg={2} md={2} sm={4} xs={4} textAlign="center">
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <Box
                                                component={'div'}
                                                sx={{
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: '#0a84ff',
                                                    cursor: 'pointer',
                                                    borderRadius: '50%', // This makes it circular,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: '#131E38',
                                                    fontWeight: 'bold',
                                                    background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)'
                                                }}

                                                onClick={() => handleDecrease(index)}
                                            >
                                                -
                                            </Box>

                                            <Typography component="span" sx={{ fontSize: '1.2rem', color: 'white', mx: 1 }}>
                                                {item?.qty}
                                            </Typography>
                                            <Box
                                                component={'div'}
                                                sx={{
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: '#0a84ff',
                                                    cursor: 'pointer',
                                                    borderRadius: '50%', // This makes it circular,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: '#131E38',
                                                    fontWeight: 'bold',
                                                    background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)'
                                                }}

                                                onClick={() => handleIncrease(index)}
                                            >
                                                +
                                            </Box>
                                        </Box>
                                    </Grid>
                                    {/* Total and Remove Button */}
                                    <Grid item lg={2} md={2} sm={4} xs={4} textAlign="center">
                                        <Typography sx={{ color: 'white' }}>    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {vendor ? item?.price * item.qty : '-'}</Typography>

                                    </Grid>
                                </Grid>
                            </Box>
                        )) : <Box sx={{ backgroundColor: '#151d2f', p: 2, borderRadius: "15px", mb: 2 }}>
                            <Grid container spacing={2} alignItems="center" justifyContent={'flex-end'}>




                                <Grid item xs={12} textAlign="center">
                                    <Typography component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                        No Items Available
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Box>}

                        {cartItems?.length > 0 && <Box sx={{ backgroundColor: '#151d2f', p: 2, borderRadius: "15px", mb: 2 }}>
                            <Grid container spacing={2} alignItems="center" justifyContent={'flex-end'}>




                                <Grid item xs={2} textAlign="center">
                                    <Typography component="span" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                        Total
                                    </Typography>
                                </Grid>
                                {/* Total and Remove Button */}
                                <Grid item xs={4} md={2} textAlign="center">
                                    <Typography sx={{ fontWeight: 'bold' }} >    {currencyType[process.env.REACT_APP_CURRENCY]?.code} {vendor ? totalAmount ? totalAmount : 0 : ''}</Typography>

                                </Grid>
                            </Grid>
                        </Box>}
                       {cartItems?.length > 0 && (
  <Grid
    container
    spacing={2}
    sx={{
      justifyContent: 'space-between',
      alignItems: 'center',
      mt: 2,
    }}
  >
    <Grid item xs={12} sm={4} md={4}>
      <PrimaryButton
        title={vendor?.name ? "Change Vendor" : "Select Vendor"}
        sx={{
          p: { xs: "8px 20px !important", sm: "10px 30px !important", md: "10px 40px !important" },
          fontWeight: 600,
          textAlign: 'center',
          borderRadius: '15px',
          background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
          color: "rgba(15, 23, 42, 1)",
          width: '100%'
        }}
        type={'submit'}
        onClick={() => {
          let state = localStorage.getItem('state')
          let city = localStorage.getItem('city')
          console.log(state);
          console.log(city);
          if (state && city) {
            if (totalAmount !== originalArray) {
              showErrorToast('Changes not saved. Please press "Update Cart" to save your changes.');
            } else {
              navigate('/merchants')
            }
          } else {
            if (totalAmount !== originalArray) {
              showErrorToast('Changes not saved. Please press "Update Cart" to save your changes.');
            } else {
              setOpen(true)
            }
          }
        }}
      />
    </Grid>

    <Grid item xs={12} sm={4} md={4}>
      <PrimaryButton
        title={"Update Cart"}
        sx={{
          p: { xs: "8px 20px !important", sm: "10px 30px !important", md: "10px 40px !important" },
          fontWeight: 600,
          textAlign: 'center',
          borderRadius: '15px',
          background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
          color: "rgba(15, 23, 42, 1)",
          width: '100%'
        }}
        type={'submit'}
        onClick={() => UpdateCart()}
      />
    </Grid>

    <Grid item xs={12} sm={4} md={4}>
      <PrimaryButton
        title={"Checkout"}
        sx={{
          p: { xs: "8px 20px !important", sm: "10px 30px !important", md: "10px 40px !important" },
          fontWeight: 600,
          textAlign: 'center',
          borderRadius: '15px',
          background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
          color: "rgba(15, 23, 42, 1)",
          width: '100%'
        }}
        onClick={() => {
          let state = localStorage.getItem('state')
          let city = localStorage.getItem('city')
          console.log(state);
          console.log(city);

          if (vendor?.name) {
            if (totalAmount !== originalArray) {
              showErrorToast('Changes not saved. Please press "Update Cart" to save your changes.');
            } else {
              navigate('/checkout', {
                state: {
                  total: total,
                  cartItems: cartItems
                }
              });
            }
          } else {
            showErrorToast('Please Select Vendor')
          }
        }}
      />
    </Grid>
  </Grid>
)}

                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}

export default Cart
